import { Switch, Box, styled } from "@mui/material";
import { DispatchWithoutAction } from "react";

interface IOSSwitchProps {
  checked: boolean;
  onClicked?: DispatchWithoutAction;
}

// Create the styled switch
const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  "&. .MuiSwitch-input": {
    left: 0,
  },
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#FC4C4C",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
  },
}));

// Create a new component that wraps the switch
export const IOSSwitch: React.FC<IOSSwitchProps> = ({
  checked,
  onClicked,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (onClicked) {
      onClicked();
    }
    e.preventDefault();
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: "inline-block",
        cursor: "pointer",
        position: "relative",
        width: 40,
        height: 20,
      }}>
      <StyledSwitch
        checked={checked}
        disableRipple
        {...props}
        sx={{
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};
